import React from "react";
import When from "../../../../components/utils/When";
import Input from "../../../base/Input";
import { BACKDROP_FILTER } from "../../../../constants/MergeConstants";
import { INPUT_TYPE_NUMBER } from "../../../../constants/ElementConstants";
import { INPUT } from "../../../../constants/InputConstants.mjs";
import { hasBackdropFilter } from "@/utils/Element/FilterUtils";
import { BACKDROP_FILTER_CONFIGS } from "@/constants/AdvancedFillModePresetConstants";

export default function AdvancedFillProperties({
  isLocked,
  getValue,
  onBackdropFilterValueChange,
  retrieveFilterValues,
}) {
  return (
    <When it={hasBackdropFilter(getValue(BACKDROP_FILTER))}>
      {BACKDROP_FILTER_CONFIGS.map((config) => (
        <Input
          key={config.filterFunctionName}
          disabled={config.disabled !== undefined ? config.disabled : isLocked}
          inputType={INPUT}
          label={config.label}
          min={config.min}
          max={config.max}
          onSIBeforeChange={onBackdropFilterValueChange(config.filterFunctionName)}
          onSIInput={onBackdropFilterValueChange(config.filterFunctionName, undefined, false)}
          type={INPUT_TYPE_NUMBER}
          units={config.units}
          value={retrieveFilterValues(config.filterFunctionName)}
        />
      ))}
    </When>
  );
}